import React, { useState } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import MasterLeftPanel from "../include/MasterLeftPanel";
import Global from "../../APIConfig";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import AuthUser from "../../AuthUser";
import MainLoader from "../Loaders/MainLoader";

function CountryAdd() {
    const navigate = useNavigate();
    const{headers1,headers2,logout}=AuthUser();
    const [countryname, setCountryname] = useState('');
    const [isocode, setIsocode] = useState('');
    const [countrycode, setCountrycode] = useState('');
    const[flag,setFlag]=useState('');
    const [Loading, setLoading] = useState(false);
    
    const handleSubmit = () => {
        if (countryname == '') {
            toast.warn('Please Enter Country Name');
        }
        else if (isocode == '') {
            toast.warn('Please Enter ISO Code');
        }
        else if (countrycode == '') {
            toast.warn('Please Enter Country code');
        }
        else {
            setLoading(true);
            axios({
                method: 'post',
                url: Global.baseUrl + 'CountryAdd',
                headers:headers2,
                data: {
                    countryname:countryname,
                    isocode:isocode,
                    countrycode: countrycode,
                    flag:flag

                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        toast.success(response.data.message);
                        setTimeout(() => {
                            navigate('/Countrylist');
                          }, 1000);
                    }
                    else {
                        if (response.data.message.countryname) {
                            toast.warn(response.data.message.countryname[0]);
                        }
                        else if (response.data.message.isocode) {
                            toast.warn(response.data.message.isocode[0]);
                        }
                        else if (response.data.message.countrycode) {
                            toast.warn(response.data.message.countrycode[0]);
                        }
                        else {
                            toast.warn(response.data.message);
                        }

                    }
                    setLoading(false);
                })
                .catch(function (error) {
                    if(error.response.status==401){
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                    setLoading(false);
                    // console.log(error);
                  });
        }
    }

    return (
        <>
            <MasterLeftPanel />
            <main className='home-section'>
                <Header />
                <ToastContainer />
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                <li className="breadcrumb-item">
                                    <a href="/Admin-Dash">
                                        <i className="bx bx-home text-primary-400 fs-6"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">Country</li>
                            </ol>
                        </nav>
                        <div className="d-flex justify-content-between">
                            <div className="">
                                <button className="btn btn_nav btn-sm" onClick={() => navigate(-1)}>
                                    <i className="bx bx-arrow-back "></i>
                                </button>
                            </div>
                            <div className="ps-2 ">
                                <h2 className="h4">Create Country</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-md">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                        <div><label htmlFor="email" className="form-label">Country Name: <span className="text-danger">*</span></label></div>
                                        <input type="text" onChange={(e)=>setCountryname(e.target.value)} className="form-control" placeholder="Enter Country Name"/>
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                        <div><label htmlFor="email" className="form-label">ISO Code: <span className="text-danger">*</span></label></div>
                                        <input type="text" onChange={(e)=>setIsocode(e.target.value)} className="form-control" placeholder="Enter Country ISO Code"/>
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                        <div><label htmlFor="email" className="form-label">Country Code: <span className="text-danger">*</span></label></div>
                                        <input type="text" onChange={(e)=>setCountrycode(e.target.value)} className="form-control" placeholder="Enter Country Code" />
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                        <div><label htmlFor="email" className="form-label">Country Flag: <span className="text-danger"></span></label></div>
                                        <input type="file" className="form-control" onChange={(e)=>setFlag(e.target.files[0])} accept="image/png, image/jpeg, image/jpg"/>
                                    </div>
                                </div>
                                {Loading==false?
                                <div className="d-grid col-md-2 mt-2">
                                    <button className="btn btn-primary" onClick={() => handleSubmit()}>Create Country</button>
                                </div>
                                :
                                <div className="d-grid col-md-2 mt-2">
                                    <a href="" className="btn btn-primary btn-block"> <div className="spinner-border text-light" role="status"><span className="visually-hidden">Loading...</span></div></a>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </main>
        </>
    );
}
export default CountryAdd;